const equipmentStatuses = ['works', 'broken', 'decommissioned', 'moving', 'maintenance', 'shipment', 'repair', 'acceptance', 'service', 'in_storage_warehouse']
const equipmentStatusesWithIds = [
  {id: 0, label: 'works'},
  {id: 1, label: 'broken'}, 
  {id: 2, label: 'decommissioned'}, 
  {id: 3, label: 'moving'}, 
  {id: 4, label: 'maintenance'}, 
  {id: 5, label: 'shipment'}, 
  {id: 6, label: 'repair'}, 
  {id: 7, label: 'acceptance'}, 
  {id: 8, label: 'in_storage_warehouse'}, 
  {id: 9, label: 'service'},
  {id: 10, label: 'turned_off'}
]
const moveStatuses = ['usage', 'storage', 'moving', 'repair']
const staffStatuses = ['accepted', 'transferred', 'vacation', 'fired'];
const watchDogSettings = ['never', '3_days', '1_week', '2_weeks', '1_month', '2_months']
const maintenanceType = ['service', 'parts']

export const userStatuses = [
  { label: "Администратор", value: "root" },
  { label: "Владелец", value: "maintainer" },
  { label: "Пользователь", value: "user" },
  { label: "Гость", value: "viewer" },
];

export const triggerTypes = [
  { value: "rfid_in", label: "RFID In", group: "global"},
  { value: "rfid_out", label: "RFID Out", group: "global"},
  { value: "rfid_switch", label: "RFID Switch", group: "global"},
  { value: "value_less_than", label: "Меньше чем", group: "equipment"},
  { value: "value_more_than", label: "Больше чем", group: "equipment"},
];

export const globalTriggerTypes = [
  { value: "rfid_in", label: "RFID In" },
  { value: "rfid_out", label: "RFID Out" },
  { value: "rfid_switch", label: "RFID Switch" },
];

export const changesTypes = [
  { value: "Sites::EquipmentItemChanges::Division", label: "division_changed" },
  { value: "Sites::EquipmentItemChanges::MoveStatus", label: "move_status_changed" },
  { value: "Sites::EquipmentItemChanges::Parent",label: "parent_changed" },
  { value: "Sites::EquipmentItemChanges::Performer", label: "performer_changed" },
  { value: "Sites::EquipmentItemChanges::Position",label: "position_changed" },
  { value: "Sites::EquipmentItemChanges::Responsible", label: "responsible_changed" },
  { value: "Sites::EquipmentItemChanges::Status",label: "status_changed" },
  { value: "Sites::EquipmentItemChanges::TriggerRfidIn",label: "triggerrfidin_changed" },
  { value: "Sites::EquipmentItemChanges::TriggerRfidOut",label: "triggerrfidout_changed" },
  { value: "Sites::EquipmentItemChanges::TriggerRfidSwitch",label: "triggerrfidswitch_changed" },
  { value: "Sites::EquipmentItemChanges::TriggerValueLessThan", label: "triggervaluelessthan_changed" },
  { value: "Sites::EquipmentItemChanges::TriggerValueMoreThan",label: "triggervaluemorethan_changed" },
  { value: "Sites::EquipmentItemChanges::Watchdog", label: "watchdog_changed" }
]


function convertRubyToJS(t) {
  switch (t) {
    case "Sites::EquipmentItemChanges::Division": return "division_changed"
    case "Sites::EquipmentItemChanges::MoveStatus": return "move_status_changed"
    case "Sites::EquipmentItemChanges::Parent": return "parent_changed"
    case "Sites::EquipmentItemChanges::Performer": return "performer_changed"
    case "Sites::EquipmentItemChanges::Position": return "position_changed"
    case "Sites::EquipmentItemChanges::Responsible": return "responsible_changed"
    case "Sites::EquipmentItemChanges::Status": return "status_changed"
    case "Sites::EquipmentItemChanges::TriggerRfidIn": return "triggerrfidin_changed"
    case "Sites::EquipmentItemChanges::TriggerRfidOut": return "triggerrfidout_changed"
    case "Sites::EquipmentItemChanges::TriggerRfidSwitch": return "triggerrfidswitch_changed"
    case "Sites::EquipmentItemChanges::TriggerValueLessThan": return "triggervaluelessthan_changed"
    case "Sites::EquipmentItemChanges::TriggerValueMoreThan": return "triggervaluemorethan_changed"
    case "Sites::EquipmentItemChanges::Watchdog": return "watchdog_changed"
    default: return "convertation_error"
  }
} 

export { equipmentStatuses, staffStatuses, moveStatuses, watchDogSettings, maintenanceType, convertRubyToJS }